import api from "../../utils/apiPublic";

export const getCategoriasPublic = async () => {
  const res = await api.get("/api/public/categorias");
  return res.data;
};
